<!-- <ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-padding">
    <ion-title class="font18 font600" color="primary">
      {{"shared.user_guest_list.select_guest" | translate}}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="primary" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header> -->

<app-header-component [headerData] = "currentHeaderData" (closeModal)="closeModal()"></app-header-component>

<ion-content>
  <ion-grid *ngIf="!userGuestList?.length; else showList" class="ion-text-center empty-state-grid">
    <ion-row class="ion-justify-content-center">
      <ion-col size="12">
        <ion-label class="font14 font500 title-text-color"
          >{{"shared.user_guest_list.your_requested_data_is_not_available" | translate}}</ion-label
        >
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showList>
    <div *ngIf="userGuestList.length > 0">
      <ion-list class="ion-padding-end ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of userGuestList"
          (click)="selectGuest(item)"
          class="ion-item-transparent-bg-color"
        >
          <ion-label>
            <p class="font14 font500 guest_name paragraph-primary-text-color">
              {{ item.firstName }} {{ item.lastName }}
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>
</ion-content>
